import React, { Component } from "react";

import SentenceTrendsHeaderOld from "./SentenceTrendsHeader";
import SentenceTrendsBodyOld from "./SentenceTrendsBody";
import QVFourEmailAndWebsiteFooter from "./QVFourEmailAndWebsiteFooter";

import { extractAreaMetrics } from "./extractMetrics";
import {
  selectThreeCategories,
  describeCategorySelection,
} from "./categoryPriority";
import { buildSentencesForCategories } from "./buildSentences";

/**
 * Legacy second-page “3 trends” dashboard (SentenceTrendsOld). Local sentence +
 * priority logic only (no PropertyUtil). Styles are namespaced with `-old`
 * class suffixes so they do not collide with `SentenceTrends`.
 */
class SentenceTrendsOld extends Component {
  componentDidMount() {
    require("./print.scss");
  }

  render() {
    const {
      agentData,
      aprilData,
      currentArea,
      hoData,
      printVersion,
      fromEditor,
      demoAccountCity,
      hasFlippedTeam,
    } = this.props;
    const { listgenUserID } = agentData;

    const metrics = extractAreaMetrics(
      aprilData,
      currentArea,
      agentData,
      hoData,
    );
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
    }

    const categoryIds = selectThreeCategories(metrics);
    const sentences = buildSentencesForCategories(categoryIds, metrics);

    return (
      <div
        className={`${printVersion ? "print" : "editor"}-qv4-second-left sentence-trends-page-old`}
      >
        <div
          className={`print-sentence-trends-old ${fromEditor ? "from-editor-old" : ""}`}
        >
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/042326_dashboard_bgimage_gold_3.png"
            alt=""
            className="dashboard-bg-old"
          />

          <SentenceTrendsHeaderOld />
          <SentenceTrendsBodyOld
            aprilData={aprilData}
            sentences={sentences}
            cityOrArea="area"
            currentArea={currentArea}
            hoData={hoData}
            printVersion={printVersion}
            agentData={agentData}
            demoAccountCity={demoAccountCity}
            hasFlippedTeam={hasFlippedTeam}
          />
        </div>
        <QVFourEmailAndWebsiteFooter
          agentData={agentData}
          currentArea={currentArea}
          printVersion={printVersion}
        />
      </div>
    );
  }
}

export default SentenceTrendsOld;
